import { render } from "./TencentTranslator.vue?vue&type=template&id=2b8a29da&scoped=true"
import script from "./TencentTranslator.vue?vue&type=script&lang=js"
export * from "./TencentTranslator.vue?vue&type=script&lang=js"

import "./TencentTranslator.vue?vue&type=style&index=0&id=2b8a29da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8a29da"]])

export default __exports__